var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{on:{"touchmove":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"pt10"},[_c('a',{staticClass:"logo",on:{"click":function($event){return _vm.getToNav()}}},[_c('img',{attrs:{"src":"static/images/logo.png"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30cad062","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderTwo.vue
// module id = null
// module chunks = 